/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-23 11:26:01
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-08-07 17:13:27
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Homepage/Homepage.tsx
 */
/**
 * Component to test other trial component
 * Author: Chris
 * CreatedAt: 2021-3-22
 */

import React from 'react';
import { withRouter } from 'react-router-dom';

import { Form } from 'src/components/Antd';

import { convertDataFromState } from './tools';
//import Co from 'src/constrains/AdvancedFilters/Collapse';
import Filter from 'src/components/AdvancedFilter';
import { EAction } from 'src/constrains/AdvancedFilters/Collapse';
import { EInclude } from 'src/constrains/AdvancedFilters/Components/CommonRadioMulSelect';
import _AbandonCheckout from './Components/AbandonCheckout';
import _ConsentAtt from './Components/ConsentAttributes';
import _Tag from './Components/CustomerTag';
import _Language from './Components/Language';
import _OrderDate from './Components/OrderDate';
import _OrderNumber from './Components/OrderNumber';
import _ProductPurchased from './Components/ProductPurchased';
import _ProductsInShoppingCart from './Components/ProductsInShoppingCart';
import _PromotionApplied from './Components/PromotionApplied';
import _RegisteredSalesChannel from './Components/RegisteredSalesChannel';
import _RegisteredSpecificTime from './Components/RegisteredSpecificTime';
import _RegistrationStatus from './Components/RegisteredStatus';
import _Subscription from './Components/Subscription';
import _TotalOrderAmount from './Components/TotalOrderAmount';
import _TermsAndConditions from './Components/TernsAndConditions';

export enum EFilterType {
  RegisteredSalesChannel = 'RegisteredSalesChannel',
  TotalOrderAmount = 'TotalOrderAmount',
  RegisteredSpecificTime = 'RegisteredSpecificTime',
  OrderDate = 'OrderDate',
  OrderNumber = 'OrderNumber',
  ProductPurchased = 'ProductPurchased',
  ProductsInShoppingCart = 'ProductsInShoppingCart',
  PromotionApplied = 'PromotionApplied',
  ConsentAttributes = 'ConsentAttributes',
  Language = 'Language',
  CustomerTag = 'CustomerTag',
  AbandonCheckout = 'AbandonCheckout',
  Subscription = 'Subscription',
  RegisteredStatus = 'RegisteredStatus',
  TermsAndConditions = 'TermsAndConditions',
}

// emit.emit(EnumAction.pageLanguageListReload, uuid);
const _RegisteredSalesChannelDefault = {
  registeredSalesChannelFilter: { selectedSalesChannelUuids: [], policy: null },
};

const _TotalOrderAmountDefault = {
  orderAmountFilter: {
    policy: null,
    value: null,
    range: { from: null, to: null },
  },
};

const _RegisteredSpecificTimeDefault = {
  registerDateFilter: {
    registered: null,
    days: null,
    policy: null,
    date: null,
    range: [],
  },
};

const _OrderDateDefault = {
  orderDateFilter: {
    searchCondition: null,
    days: null,
    policy: null,
    date: null,
    range: [],
  },
};

const _OrderNumberDefault = {
  orderCountFilter: {
    orderStatus: null,
    policy: null,
    value: null,
    range: { from: null, to: null },
  },
};

const _ProductsInShoppingCartDefault = {
  shoppingCartFilter: {
    include: null,
    selectedProducts: [],
  },
};

const _ProductPurchasedDefault = {
  productPurchasedFilter: {
    include: null,
    selectedProducts: [],
  },
};

const _PromotionDefault = {
  discountFilter: {
    include: null,
    selectedDiscounts: [],
  },
};

const _ConsentAttDefault = {
  consentAttributeFilter: {
    include: null,
    selectedConsentAttributes: [],
  },
};

const _TAndCDefault = {
  tacFilter: {
    include: null,
    tacUuids: [],
  },
};

const _LanguageDefault = {
  languageFilter: {
    selectedLanguages: [],
  },
};

const _SubscriptionDefault = {
  subscriptionFilter: {
    subscribed: null,
  },
};

const _AbandonCheckoutDefault = {
  abandonCheckoutFilter: {
    abandonedCheckout: null,
  },
};

const _RegistrationStatusDefault = {
  registrationStatusFilter: { registrationStatus: null },
};

const _TagDefault = {
  tagFilter: {
    include: null,
    selectedTags: [],
  },
};

const _TermsAndConditionsDefault = {
  tacFilter: {
    include: null,
    tacUuids: [],
  },
};

const AdvancedFilter = (props) => {
  const {
    isSub,
    display,
    setDisplay,
    fieldsData,
    onConfirm,
    filterList = [],
    iniTag,
  } = props; //以后可以按照filter type 来注册
  //console.log('AdvancedFilter', iniTag);
  //e2cdab47-d4ad-463a-9468-50a4ec617181
  // const _TagDefault = {
  // tagFilter: {
  //   include: iniTag ? EInclude.any : null,
  //   selectedTags: iniTag ? [iniTag] : [],
  // },
  // };

  const [form1] = Form.useForm();
  const {
    salesChannels,
    consentAttributes,
    currency,
    availableTags,
    availablePromotions,
    availableLanguages,
    salesChannelTacList,
  } = fieldsData || {};
  // const [display, setDisplay] = React.useState(false);
  const ini = isSub
    ? {
        ..._RegisteredSalesChannelDefault,
        ..._ConsentAttDefault,
        ..._RegistrationStatusDefault,
      }
    : {
        ..._AbandonCheckoutDefault,
        ..._SubscriptionDefault,
        ..._TagDefault,
        ..._LanguageDefault,
        ..._ConsentAttDefault,
        ..._PromotionDefault,
        ..._ProductPurchasedDefault,
        ..._ProductsInShoppingCartDefault,
        ..._OrderNumberDefault,
        ..._OrderDateDefault,
        ..._RegisteredSpecificTimeDefault,
        ..._TotalOrderAmountDefault,
        ..._RegisteredSalesChannelDefault,
        ..._TermsAndConditionsDefault,
      };

  const map = {
    [EFilterType.RegisteredSalesChannel]: (
      <_RegisteredSalesChannel
        options={salesChannels || []}
        radioName={['registeredSalesChannelFilter', 'policy']}
        form={form1}
        noStyle
        name={['registeredSalesChannelFilter', 'selectedSalesChannelUuids']}
        defaultState={_RegisteredSalesChannelDefault}
      />
    ),
    [EFilterType.TotalOrderAmount]: (
      <_TotalOrderAmount
        currency={currency}
        noStyle
        form={form1}
        defaultState={_TotalOrderAmountDefault}
        rootName='orderAmountFilter'
        suffix='AUD'
        nameType={['orderAmountFilter', 'policy']}
        nameValue={['orderAmountFilter', 'value']}
        nameRange={['orderAmountFilter', 'range']}
      />
    ),
    [EFilterType.RegisteredSpecificTime]: (
      <_RegisteredSpecificTime
        noStyle
        form={form1}
        defaultState={_RegisteredSpecificTimeDefault}
        rootName='registerDateFilter'
        selectName={['registerDateFilter', 'registered']}
        daysName={['registerDateFilter', 'days']}
        policyName={['registerDateFilter', 'policy']}
        singleDayName={['registerDateFilter', 'date']}
        dayRangeName={['registerDateFilter', 'range']}
      />
    ),
    [EFilterType.OrderDate]: (
      <_OrderDate
        noStyle
        form={form1}
        defaultState={_OrderDateDefault}
        rootName='orderDateFilter'
        selectName={['orderDateFilter', 'searchCondition']}
        daysName={['orderDateFilter', 'days']}
        policyName={['orderDateFilter', 'policy']}
        singleDayName={['orderDateFilter', 'date']}
        dayRangeName={['orderDateFilter', 'range']}
      />
    ),
    [EFilterType.OrderNumber]: (
      <_OrderNumber
        noStyle
        form={form1}
        defaultState={_OrderNumberDefault}
        rootName='orderCountFilter'
        nameType={['orderCountFilter', 'policy']}
        nameValue={['orderCountFilter', 'value']}
        nameRange={['orderCountFilter', 'range']}
        selectName={['orderCountFilter', 'orderStatus']}
      />
    ),
    [EFilterType.ProductsInShoppingCart]: (
      <_ProductsInShoppingCart
        noStyle
        form={form1}
        defaultState={_ProductsInShoppingCartDefault}
        rootName='shoppingCartFilter'
        radioName={['shoppingCartFilter', 'include']}
      />
    ),
    [EFilterType.ProductPurchased]: (
      <_ProductPurchased
        noStyle
        form={form1}
        defaultState={_ProductPurchasedDefault}
        rootName='productPurchasedFilter'
        radioName={['productPurchasedFilter', 'include']}
      />
    ),
    [EFilterType.PromotionApplied]: (
      <_PromotionApplied
        noStyle
        form={form1}
        defaultState={_PromotionDefault}
        radioName={['discountFilter', 'include']}
        selectName={['discountFilter', 'selectedDiscounts']}
        rootName={'discountFilter'}
        selectOptions={availablePromotions}
      />
    ),
    [EFilterType.ConsentAttributes]: (
      <_ConsentAtt
        noStyle
        form={form1}
        defaultState={_ConsentAttDefault}
        radioName={['consentAttributeFilter', 'include']}
        selectName={['consentAttributeFilter', 'selectedConsentAttributes']}
        rootName={'consentAttributeFilter'}
        selectOptions={consentAttributes}
      />
    ),
    [EFilterType.Language]: (
      <_Language
        options={availableLanguages}
        noStyle
        form={form1}
        name={['languageFilter', 'selectedLanguages']}
        defaultState={_LanguageDefault}
      />
    ),
    [EFilterType.CustomerTag]: (
      <_Tag
        form={form1}
        defaultState={_TagDefault}
        radioName={['tagFilter', 'include']}
        selectName={['tagFilter', 'selectedTags']}
        rootName={'tagFilter'}
        selectOptions={availableTags}
      />
    ),
    [EFilterType.AbandonCheckout]: (
      <_AbandonCheckout
        form={form1}
        defaultState={_AbandonCheckoutDefault}
        radioName={['abandonCheckoutFilter', 'abandonedCheckout']}
        rootName={'abandonCheckoutFilter'}
      />
    ),
    [EFilterType.Subscription]: (
      <_Subscription
        form={form1}
        defaultState={_SubscriptionDefault}
        radioName={['subscriptionFilter', 'subscribed']}
        rootName={'subscriptionFilter'}
      />
    ),
    [EFilterType.RegisteredStatus]: (
      <_RegistrationStatus
        noStyle
        form={form1}
        defaultState={_RegistrationStatusDefault}
        radioName={['registrationStatusFilter', 'registrationStatus']}
        rootName={'registrationStatusFilter'}
      />
    ),
    [EFilterType.TermsAndConditions]: (
      <_TermsAndConditions
        noStyle
        form={form1}
        defaultState={_TAndCDefault}
        radioName={['tacFilter', 'include']}
        selectName={['tacFilter', 'tacUuids']}
        rootName={'tacFilter'}
        selectOptions={salesChannelTacList}
      />
    ),
  };

  React.useEffect(() => {
    if (iniTag) {
      //  console.log('iniTag1', iniTag);
      const v = {
        ...ini,
        tagFilter: {
          include: EInclude.any,
          selectedTags: [iniTag],
        },
      };

      form1.setFieldsValue(v);

      setTimeout(() => {
        form1.submit();
      }, 100);
      // form1.validateFields(['tagFilter']).then(() => {
      //   console.log('okok');
      //   form1.submit();
      // });
      // setTimeout(() => {

      // });
    } else {
      form1.setFieldsValue(ini);
      //console.log('iniTag2', iniTag);
    }
  }, []);

  const onClose = () => {
    setDisplay(false);
  };
  const resetAll = () => {
    form1.setFieldsValue(ini);
    window.dispatchEvent(new Event(EAction.CLOSE));
    onClose();
    form1.submit();
  };

  const handleOnSubmit = () => {
    window.dispatchEvent(new Event(EAction.CLOSE));
    setTimeout(() => {
      form1.submit();
    }, 100);
  };

  const onFinish = (values) => {
    onClose();
    // console.log(form1.getFieldsValue());
    const _v = convertDataFromState(values);
    if (onConfirm) onConfirm(_v);
  };

  const generateForm = () => {
    if (isSub) {
      return (
        <React.Fragment>
          <_RegisteredSalesChannel
            options={salesChannels || []}
            radioName={['registeredSalesChannelFilter', 'policy']}
            form={form1}
            noStyle
            name={['registeredSalesChannelFilter', 'selectedSalesChannelUuids']}
            defaultState={_RegisteredSalesChannelDefault}
            title='Subscribed sales channel '
          />
          <_ConsentAtt
            noStyle
            form={form1}
            defaultState={_ConsentAttDefault}
            radioName={['consentAttributeFilter', 'include']}
            selectName={['consentAttributeFilter', 'selectedConsentAttributes']}
            rootName={'consentAttributeFilter'}
            selectOptions={consentAttributes}
          />
          <_RegistrationStatus
            noStyle
            form={form1}
            defaultState={_RegistrationStatusDefault}
            radioName={['registrationStatusFilter', 'registrationStatus']}
            rootName={'registrationStatusFilter'}
          />
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          {filterList.map((i) => {
            return <React.Fragment key={i}>{map[i]}</React.Fragment>;
          })}
        </React.Fragment>
      );
    }
  };

  return (
    <Filter
      resetAll={resetAll}
      handleOnSubmit={handleOnSubmit}
      visible={display}
      onClose={onClose}
      onFinish={onFinish}
      initialValues={ini}
      form={form1}>
      {generateForm()}
    </Filter>

    //
  );
};
export default withRouter(AdvancedFilter);
